export default function HeroSection() {
  const scrollToQRCode = () => {
    const element = document.getElementById('qrcode');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/7f3b2cc090efaeb3be34d354b6840566.jpg"
          alt="Personal Brand Hero"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center text-white pt-20">
        <div className="inline-flex items-center gap-2 px-5 py-2.5 bg-white/10 backdrop-blur-sm rounded-full mb-8 border border-white/20">
          <i className="ri-fire-line text-xl text-amber-400"></i>
          <span className="text-sm font-semibold">Ưu Đãi Đặc Biệt - Chỉ Còn 70.000đ</span>
        </div>

        <h1 className="text-5xl md:text-7xl font-bold mb-6 leading-tight">
          Xây Dựng Thương Hiệu<br />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-teal-400 to-amber-400">
            Cá Nhân Chuyên Nghiệp
          </span>
        </h1>

        <p className="text-xl md:text-2xl mb-10 text-white/90 max-w-3xl mx-auto leading-relaxed">
          Tạo dựng hình ảnh chuyên nghiệp, thu hút khách hàng và phát triển sự nghiệp với trang thương hiệu cá nhân độc đáo
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
          <button
            onClick={scrollToQRCode}
            className="whitespace-nowrap px-10 py-4 bg-gradient-to-r from-teal-500 to-teal-600 text-white text-lg font-bold rounded-full hover:from-teal-600 hover:to-teal-700 transition-all duration-300 shadow-2xl hover:shadow-teal-500/50 transform hover:scale-105 cursor-pointer"
          >
            Đăng Ký Ngay - Chỉ 70K
          </button>
          <button
            onClick={() => {
              const element = document.getElementById('benefits');
              if (element) element.scrollIntoView({ behavior: 'smooth' });
            }}
            className="whitespace-nowrap px-10 py-4 bg-white/10 backdrop-blur-sm text-white text-lg font-semibold rounded-full hover:bg-white/20 transition-all duration-300 border-2 border-white/30 cursor-pointer"
          >
            Tìm Hiểu Thêm
          </button>
        </div>

        <div className="grid grid-cols-3 gap-8 max-w-3xl mx-auto pt-8 border-t border-white/20">
          <div>
            <div className="text-4xl font-bold mb-2 text-teal-400">500K</div>
            <div className="text-sm text-white/80">Giá Trị Thực</div>
          </div>
          <div>
            <div className="text-4xl font-bold mb-2 text-amber-400">70K</div>
            <div className="text-sm text-white/80">Giá Ưu Đãi</div>
          </div>
          <div>
            <div className="text-4xl font-bold mb-2 text-rose-400">86%</div>
            <div className="text-sm text-white/80">Tiết Kiệm</div>
          </div>
        </div>
      </div>
    </section>
  );
}